import React, { useState, useRef, useEffect } from "react"
import { HeaderBackTitle } from "../common/header"
import { VehicleListByBrand, PopularCarBrands } from "."
import ScrollContainer from "react-indiana-drag-scroll"
import { FiX } from "react-icons/fi";
import { _getAllVehicleTopList, generateFilterToUrl } from "../../libraries/common"
import _ from "lodash"
import { useRouter } from "next/router"
import Link from 'next/link';
import { pageLink, priceOption } from "../../config/site"
import Redux from "@/action";
import { Footer } from "../common/footer"
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { MyBody } from "../body/body";
import { CustomLink } from "../app/customLink";

const tagDefaultList = {
    bodytype: [
        {value: 'sedan', label: 'Sedan'},
        {value: 'hatchback', label: 'Hatchback'},
        {value: 'suv', label: 'SUV'},
        {value: 'cabriolet', label: 'Cabriolet'},
        {value: 'sport', label: 'Sport'},
        {value: 'mpv', label: 'MPV'},
        {value: 'truck', label: 'Truck'},
        {value: 'wagon', label: 'Wagon'},
        {value: 'pickup', label: 'Pickup'}
    ],
    price: priceOption,
    segment: [
        {value: 'A-Segment', label: 'A-Segment'},
        {value: 'B-Segment', label: 'B-Segment'},
        {value: 'C-Segment', label: 'C-Segment'},
        {value: 'D-Segment', label: 'D-Segment'},
        {value: 'E-Segment', label: 'E-Segment'},
        {value: 'Commercial', label: 'Commercial'},
        {value: 'Executive', label: 'Executive'},
        {value: 'Grand Tourer', label: 'Grand Tourer'},
        {value: 'Luxury', label: 'Luxury'},
        {value: 'Sports Car', label: 'Sports Car'},
        {value: 'Super Car', label: 'Super Car'},
        {value: 'Compact Executive', label: 'Compact Executive'},
        {value: '4x4', label: '4x4'},
    ],
    transmission: [
        {value: 'MT', label: 'MT'},
        {value: 'AMT', label: 'AMT'},
        {value: 'CVT', label: 'CVT'},
        {value: 'DCT', label: 'DCT'},
        {value: 'AT', label: 'AT'},
        {value: 'MCT', label: 'MCT'},
        {value: 'EV', label: 'EV'},
        {value: 'E-CVT', label: 'E-CVT'},
    ],
    fuel: [
        {value: 'Petrol', label: 'Petrol'},
        {value: 'Diesel', label: 'Diesel'},
        {value: 'Petrol Hybrid', label: 'Petrol Hybrid'},
        {value: 'EV', label: 'EV'},
    ],
    seats: [
        {value: '2', label: '2 Seats'},
        {value: '4', label: '4 Seats'},
        {value: '5', label: '5 Seats'},
        {value: '6', label: '6 Seats'},
        {value: '7', label: '7 Seats'},
        {value: '8', label: '8 Seats'},
        {value: '10', label: '10 Seats'},
        {value: '11', label: '11 Seats'},
        {value: '12', label: '12 Seats'},
        {value: '15', label: '15 Seats'},
    ],
    driveline: [
        {value: 'Front Wheel Drive', label: 'Front Wheel Drive'},
        {value: 'Rear Wheel Drive', label: 'Rear Wheel Drive'},
        {value: 'All Wheel Drive', label: 'All Wheel Drive'},
    ],
    featuresSpecs: [
        {value: 'cruise_control', label: 'Cruise Control'},
        {value: 'hill_start_assist', label: 'Hill Start Assist'},
        {value: 'sunroof', label: 'Sunroof'},
        {value: 'paddle_shift', label: 'Paddle Shift'},
        {value: 'sunshade', label: 'Sunshade'},
        {value: 'bluetooth', label: 'Car Bluetooth'},
        {value: 'isofix', label: 'ISOFIX'},
        {value: 'abs_ebd', label: 'ABS System'},
    ]
}

const getQuery = (query) => {
    const newQuery = _.omit(query, 'vehicle')
    let queryList = []
    queryList = _.mapValues(newQuery, (value, key) => {
        if(key != "price"){
            return value.split(',');
        }
    });

    return {...queryList, "price": newQuery?.['price']}
}

export const VehicleFilterResult = (props) => {
    const { t, device, session, params, query, fetchedData } = props
    const { store, dispatch } = Redux();
    const [loading, setLoading] = useState(true)
    const [matchCount, setMatchCount] = useState(fetchedData?.filterResult.total);
    const [vehicleList, setVehicleList] = useState(fetchedData?.filterResult.vehicleList);
    const [filterLink, setFilterLink] = useState('');
    const router = useRouter()

    // top List brand and model
    const [vehicleTopList, setVehicleTopList] = useState({brand: [], model: []})
    const [filter, setFilter] = useState(getQuery(fetchedData?.request) ?? {brand: [], price: [], bodytype: [], segment: [], transmission: [], fuel: [], seats: [], driveline: [], featuresSpecs: []} )
    const tagList = {
        ...tagDefaultList,
        brand: _.map(fetchedData?.vehicleBrandList, (item) => {
            return { value: item.brand_custom_url, label: item.name };
        })
    }

    useEffect(()=>{
        const fetchData = async() => {
            try{
                if(store?.path?.dataAllVehicleTopList == undefined){
                    await _getAllVehicleTopList(dispatch);
                }
            } catch(error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
        fetchData();
    },[])

    useEffect(()=>{
        setFilter(getQuery(fetchedData?.request));
    },[query])

    const _removeClick = (value, type) =>{
        let newFilter = {}
        let filterData = [...filter[type]]
        if(type == "price"){
            if(_.some(filter["price"], { 'label': value.label })){
                // remove value then already inside array
                filterData = _.filter(filter["price"], (item) => item?.label != value?.value?.label);
            }
        } else {
            if(_.includes(filter[type], value?.value)){
                // remove value then already inside array
                filterData = _.filter(filter[type], (item) => item != value?.value);
            }
        }
        
        newFilter = { ...filter, [type]: filterData };

        let filterLink = generateFilterToUrl(newFilter)
        
        if (!_.isEmpty(filterLink)) {
            filterLink = '?'+filterLink;
        }

        router.push(pageLink.vehicle.filterResult+filterLink)
    }

    return (
        <>
            <AllMeta
                title={t('vehicleFilterResultPage_meta_title')}
                description={t('vehicleFilterResultPage_meta_description')}
                keyword={t('vehicleFilterResultPage_meta_keyword')}
            />
            <Head><title>{t('vehicleFilterResultPage_title')}</title></Head>
            <MyBody
                t={t}
                headerComponent={
                    <HeaderBackTitle 
                        title={t("car_filter")} 
                        showSearch={false}
                        showMenu={false}
                        t={t}
                    />
                }
                navigaitionComponent={
                    <div className="vehicleFilterResult_bottom containerPadding">
                        <CustomLink href={pageLink.vehicle.filter}>
                            <div className="vehicleFilter_bottomNavigation_search cursorPointer">
                                <p className="fontSize_16 fontWeight_bold fontColor_white">
                                    {t('filter')}
                                </p>
                            </div>
                        </CustomLink>
                    </div>
                }
            >
                <div className="vehicleFilterResult_matchesFoundBox containerPadding">
                    <p className="fontSize_18">
                        {`${fetchedData?.filterResult.total} ${t('matches_found')}`}
                    </p>
                </div>
                <ScrollContainer className="vehicleFilterResult_searchFilterList">
                    <div className="vehicleFilterResult_searchFilterWrap containerPadding">
                        <CustomLink href={pageLink.vehicle.filterResult}>
                            <div className="vehicleFilterResult_searchFilterItem">
                                <p className="fontSize_14 fontColor_white vehicleFilterResult_searchFilterItem_text">
                                    {t('clear_all')}
                                </p>
                            </div>
                        </CustomLink>
                        {
                            _.reduce(filter,( result, value, key )=>{
                                result.push(
                                    <React.Fragment key={key}>
                                        {
                                            _.reduce(value,( result2, value2, key2 )=>{
                                                let currentValue = {}
                                                currentValue = key == "price" 
                                                ? _.find(tagList[key], { label: value2?.label })
                                                : _.find(tagList[key], { value: value2 })

                                                if(!_.isEmpty(currentValue)){
                                                    result2.push(
                                                        <div key={`${key}-${key2}`} className="vehicleFilterResult_searchFilterItem">
                                                            <FiX onClick={()=>{_removeClick(currentValue, key)}} className='vehicleFilterResult_searchFilterItem_closeIcon cursorPointer'/>
                                                            <p className="fontSize_14 fontColor_white vehicleFilterResult_searchFilterItem_text">
                                                                {currentValue.label}
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                                
                                                return result2
                                            },[])
                                        }
                                    </React.Fragment>
                                )
                                return result
                            },[])
                        }
                    </div>
                </ScrollContainer>
                <div className="vehicleFilterResult_vehicleListByBrandOuter">
                    <VehicleListByBrand data={fetchedData?.filterResult.vehicleList} t={t} />
                </div>
                <div className="vehicleFilterResult_placementBannerMargin">
                </div>
                <div className="vehicleBrandsPopularCarMargin">
                    <PopularCarBrands t={t} data={store?.path?.dataAllVehicleTopList?.brand} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
                </div>
            </MyBody>
        </>
    )
    
    // return (
    //     <>
    //         <AllMeta
    //             title={t('vehicleFilterResultPage_meta_title')}
    //             description={t('vehicleFilterResultPage_meta_description')}
    //             keyword={t('vehicleFilterResultPage_meta_keyword')}
    //         />
    //         <Head><title>{t('vehicleFilterResultPage_title')}</title></Head>
    //         <div className='bodyContainer'>
    //             <div className='contentContainer bodyContainerHasBottomNavigation'>
    //                 <HeaderBackTitle 
    //                     title={t("car_filter")} 
    //                     showSearch={false}
    //                     showMenu={false}
    //                     t={t}
    //                 />
    //                 <div className="vehicleFilterResult_matchesFoundBox containerPadding">
    //                     <p className="fontSize_18">
    //                         {`${fetchedData?.filterResult.total} ${t('matches_found')}`}
    //                     </p>
    //                 </div>
    //                 <ScrollContainer className="vehicleFilterResult_searchFilterList">
    //                     <div className="vehicleFilterResult_searchFilterWrap containerPadding">
    //                         <Link href={pageLink.vehicle.filterResult}>
    //                             <div className="vehicleFilterResult_searchFilterItem">
    //                                 <p className="fontSize_14 fontColor_white vehicleFilterResult_searchFilterItem_text">
    //                                     {t('clear_all')}
    //                                 </p>
    //                             </div>
    //                         </Link>
    //                         {
    //                             _.reduce(filter,( result, value, key )=>{
    //                                 result.push(
    //                                     <React.Fragment key={key}>
    //                                         {
    //                                             _.reduce(value,( result2, value2, key2 )=>{
    //                                                 let currentValue = {}
    //                                                 currentValue = key == "price" 
    //                                                 ? _.find(tagList[key], { label: value2?.label })
    //                                                 : _.find(tagList[key], { value: value2 })

    //                                                 if(!_.isEmpty(currentValue)){
    //                                                     result2.push(
    //                                                         <div key={`${key}-${key2}`} className="vehicleFilterResult_searchFilterItem">
    //                                                             <FiX onClick={()=>{_removeClick(currentValue, key)}} className='vehicleFilterResult_searchFilterItem_closeIcon cursorPointer'/>
    //                                                             <p className="fontSize_14 fontColor_white vehicleFilterResult_searchFilterItem_text">
    //                                                                 {currentValue.label}
    //                                                             </p>
    //                                                         </div>
    //                                                     )
    //                                                 }
                                                    
    //                                                 return result2
    //                                             },[])
    //                                         }
    //                                     </React.Fragment>
    //                                 )
    //                                 return result
    //                             },[])
    //                         }
    //                     </div>
    //                 </ScrollContainer>
    //                 <div className="vehicleFilterResult_vehicleListByBrandOuter">
    //                     <VehicleListByBrand data={fetchedData?.filterResult.vehicleList} t={t} />
    //                 </div>
    //                 <div className="vehicleFilterResult_placementBannerMargin">
    //                 </div>
    //                 <div className="vehicleBrandsPopularCarMargin">
    //                     <PopularCarBrands t={t} data={store?.path?.dataAllVehicleTopList?.brand} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
    //                 </div>
    //                 <Footer t={t} />
    //             </div>
    //             <div className="vehicleFilterResult_bottom containerPadding">
    //                 <Link href={pageLink.vehicle.filter}>
    //                     <div className="vehicleFilter_bottomNavigation_search cursorPointer">
    //                         <p className="fontSize_16 fontWeight_bold fontColor_white">
    //                             {t('filter')}
    //                         </p>
    //                     </div>
    //                 </Link>
    //             </div>
    //         </div>
    //     </>
    // )
}